var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7174 3.76453H18.1855V13.4128C18.1855 18.2966 16.4783 20.8257 12.1247 20.8257C7.35802 20.8257 6.53503 16.9419 6.53503 13.4128V3.76453H0V16.1774C0 21.5291 4.29549 27.2355 12.0635 27.2355C20.7738 27.2355 24.7174 21 24.7174 16.1774V3.76453ZM15.6553 3.76453H9.06215V45H15.6522V3.76453H15.6553ZM35.8998 26.5902V8.9419H36.0161L40.489 26.5902H35.8998ZM29.3097 45.0031H35.8998V32.5902H44.552C47.2015 32.5902 48.5538 31.0612 47.7889 28.2385L42.6674 9.59021C41.4895 5.35168 39.1367 3 35.4286 3C31.485 3 29.3067 6.23547 29.3067 10.2936V45L29.3097 45.0031Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFood);
export default __webpack_public_path__ + "static/media/icon_food.8dea4e710993fde4cdbdf3b5742d52c8.svg";
export { ForwardRef as ReactComponent };